import { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearErr, fetchPlatformAuth } from "../../store/authSlice";
import PlatformAuthShell from "../Clinic/Auth/PlatformAuthShell";
import AuthField from "../Clinic/Auth/AuthField";
import Button from "../ui/Button";
import a from "../Clinic/Auth/auth.module.css";

export default function PlatformAdminLoginPage() {
  const dispatch = useDispatch();
  const { err, load } = useSelector((state) => state.auth);
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");

  const submit = (e) => {
    e.preventDefault();
    dispatch(clearErr());
    dispatch(fetchPlatformAuth({ login, password }));
  };

  const errorText =
    typeof err === "string" ? err : err?.message || err?.error || null;

  return (
    <PlatformAuthShell
      backTo="/"
      backLabel="На главную"
      title="Админка платформы"
      subtitle="Управление тарифами, клубами и аналитикой сервиса. Отдельно от админки спортивной секции."
      footer={
        <p className={a.platformFootNote}>
          Нужна админка вашего клуба?{" "}
          <Link to="/find">Найти клуб и войти</Link>
        </p>
      }
    >
      {errorText ? <div className={a.errorBox}>{errorText}</div> : null}
      <form onSubmit={submit}>
        <AuthField
          label="Email"
          id="admin-email"
          type="email"
          value={login}
          onChange={(e) => setLogin(e.target.value)}
          required
          autoComplete="username"
        />
        <AuthField
          label="Пароль"
          id="admin-password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          autoComplete="current-password"
        />
        <div className={a.actions}>
          <Button type="submit" block size="lg" disabled={load}>
            {load ? "Вход…" : "Войти"}
          </Button>
        </div>
      </form>
    </PlatformAuthShell>
  );
}
